import {Component, OnInit} from '@angular/core';
import {PageTitleComponent} from "../../components/page-title/page-title.component";
import {ButtonDirective, ButtonLabel} from "primeng/button";
import {RouterLink} from "@angular/router";

@Component({
  standalone: true,
  imports: [
    PageTitleComponent,
    ButtonDirective,
    ButtonLabel,
    RouterLink
  ],
  templateUrl: './not-found-page.component.html',
})
export class NotFoundPageComponent implements OnInit {
    ngOnInit(): void {
       console.error('404 Page loaded');
    }
}
